import { track } from "~/modules/analytics/track";
import { NavigationUserEvents } from "~/modules/analytics/events/navigation";

// // // //

/**
 * trackExpandSidebar
 * Tracks the event when a user expands the sidebar
 */
export function trackExpandSidebar() {
    track(NavigationUserEvents.expandSidebar);
}

/**
 * trackCollapseSidebar
 * Tracks the event when a user collapses the sidebar
 */
export function trackCollapseSidebar() {
    track(NavigationUserEvents.collapseSidebar);
}
